
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeft, Globe } from "lucide-react";
import AdminPageBackground from "@/components/admin/AdminPageBackground";
import { Button } from "@/components/ui/button";

const Analytics = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  return (
    <AdminPageBackground className={isRTL ? "rtl" : "ltr"}>
      <nav className="border-b border-white/10 bg-white/5 backdrop-blur-sm">
        <div className="max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link
              to="/admin-dashboard"
              className="flex items-center gap-2 text-white/70 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              {isRTL ? "العودة للوحة التحكم" : "Back to Dashboard"}
            </Link>
            <Button
              variant="ghost"
              size="icon"
              onClick={() => i18n.changeLanguage(i18n.language === "en" ? "ar" : "en")}
              className="rounded-full text-white/70 hover:text-white hover:bg-white/10"
            >
              <Globe className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </nav>

      <main className="max-w-[2000px] mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <h1 className="text-3xl font-bold mb-8 text-white">
          {isRTL ? "التحليلات" : "Analytics"}
        </h1>

        <div className="bg-white/10 backdrop-blur-md rounded-lg border border-white/15 p-6">
          <div className="text-center text-white/50">
            {isRTL 
              ? "قسم التحليلات قيد التطوير"
              : "Analytics section is under development"
            }
          </div>
        </div>
      </main>
    </AdminPageBackground>
  );
};

export default Analytics;
